export const RetryDelays = new Array<number>();

// Increase delay linearly up to 15 seconds, add a small random jitter of at most 1.5 seconds.
// This will retry for around 15 minutes at most, then we should give up.
for (let i = 0; i < 40; i++) {
    const delay = 1000 * Math.min(i + 1, 15);
    const randomFactor = (Math.random() * delay) / 10;
    RetryDelays[i] = delay + randomFactor;
}
